export default {
  namespaced: true,
  getters: {
    elements: (state, getters, rootState, rootGetters) => (element = new Object) => {
      let components = rootGetters['layoutModule/components']
      return Object.prototype.hasOwnProperty.call(element, 'layoutPageComponent') ? components[element.layoutPageComponent] : components
    },
    index: (state, getters) => id => getters.elements().findIndex(pageComponent => pageComponent.id == id),
    id: (state, getters) => element =>  getters.elements(element).id,
    styles: (state, getters) => (element, styles = 'styles') => getters.elements(element)[styles],
    classes: (state, getters) => (element, classes = 'classes') => getters.elements(element)[classes],
    content: (state, getters) => (element) => getters.elements(element).content,
    background: (state, getters) => element => getters.elements(element).background,
    assets: (state, getters) => element => getters.elements(element).assets,
    properties: (state, getters) => element => getters.elements(element).properties
  },
  actions: {
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'layoutPageComponentModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    }, 
    addToArray({commit}, payload) {
      payload = {...payload, module: 'layoutPageComponentModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'layoutPageComponentModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'layoutPageComponentModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
  }
}